import React from "react";
import * as Location from "expo-location";
import {storageFunctions} from "./storage";
import Order from "./rest/jtmc/models/Order";
import {CartItem} from "./contexts/CartContext";

export function findChildByRole(childProps: any, props: any, role: string): JSX.Element {
    let rv = <></>;
    React.Children.map(props.children, (child) => {
        if (child.props.role == role)
            rv = React.cloneElement(child, childProps);
    });
    return rv;
}

export function hexToRgbA(hex: string) {
    let c: any;
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split('');
        if (c.length == 3) {
            c = [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c = '0x' + c.join('');
        let r = `rgba(${[(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',')},1)`;
        return r;
    }
    throw new Error('Bad Hex');
}

export async function askLocation(snackErrorMenu: any) {
    return Location.requestForegroundPermissionsAsync().then(({status}) => {
        if (status !== 'granted')
            throw 'برای یافتن موقعیت کنونی، مجوز دسترسی به موقعیت مکانی را صادر کنید';
        return Location.getCurrentPositionAsync({});
    })
}

export function randomStr(length: number): string {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
        counter += 1;
    }
    return result;
}

export function roundDownToman(n: number) {
    return Math.round(n / 1000) * 1000;
}


export function checkLogin() {
    const resolver = (resolve: any) => {
        storageFunctions.getData("api_key").then((apiToken) => {
            resolve(apiToken != null);
        });
    }
    return new Promise<boolean>(resolver);
}

export function threeDigitsSep(n: number) {
    return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function checkNotificationAccess(): boolean {
    return Notification.permission === "granted";
}

export function notificationAccessNotDenied(): boolean {
    return Notification.permission !== "denied";
}

export async function askNotificationAccess() {
    return new Promise(function (resolve, reject) {
        const permissionResult = Notification.requestPermission(function (result) {
            resolve(result);
        });
        if (permissionResult) {
            permissionResult.then(resolve, reject);
        }
    }).then((permissionResult) => {
        return permissionResult === 'granted';
    });
}


let ipgWindow: any = null;
export function openUrlWithIpgCallbackChannelSubscribe(url: string, id: number, onPaid: () => void, onCancel: () => void) {
    openURL(url);
    const socketAddress = `ipg.${id}`;
    // @ts-ignore
    window.Echo.private(socketAddress).listen('IPGCallbackEvent', (e: any) => {
        ipgWindow.close();
        try {
            const order = new Order(e);
            if (order.isPaid)
                onPaid();
            else onCancel();
        } catch (e) {

        }
    });
}

function openURL(url: string) {
    ipgWindow = window.open(url, "_blank");
    return false;
}

export function originIsPWA(): boolean {
    const urlParams = new URLSearchParams(window.location.search);
    const origin = urlParams.get('origin');
    if (origin == null)
        return false;
    return origin == "pwa";
}
export function redirectToMeezbanLanding() {
    open("https://meezban.net/", "_self");
}
